import React, { useState } from "react"
import CustomButton from "components/Atoms/CustomButton"
import AnalyticsCard from "components/Templates/analytics/AnalyticsCard"
import AnalyticsCardGrid from "components/Templates/analytics/AnalyticsCardGrid"
import AnalyticsDrawer, {
  AggregationNotAvailable,
} from "components/Templates/analytics/AnalyticsDrawer"
// import AnalyticsDrawer, {
//   AggregationNotAvailable,
// } from "components/Templates/AnalyticsDrawer";
import ContainerSpinner from "components/Templates/ContainerSpinner"
import { useSummaryAllOrders } from "graphql/dispatch/dispatch.hooks"

const SummaryOrdersDrawer = ({ className }) => {
  const { data, loading } = useSummaryAllOrders()
  const [isOpen, setOpen] = useState(false)

  const s = data?.summaryAllOrders

  return (
    <>
      <CustomButton
        className={className}
        icon="pie-chart"
        onClick={e => setOpen(true)}
      />
      <AnalyticsDrawer
        title="Summary of orders"
        isOpen={isOpen}
        onClose={e => setOpen(false)}
      >
        {loading ? (
          <ContainerSpinner />
        ) : data?.summaryAllOrders ? (
          <AnalyticsCardGrid>
            <AnalyticsCard
              intent="primary"
              title="Order Count"
              value={s?.orderCount}
            />
            <AnalyticsCard
              intent="primary"
              title="Placed"
              value={s?.statusPlaced}
            />
            <AnalyticsCard
              title="Confirmed"
              intent="warning"
              value={s?.statusConfirmed}
            />
            <AnalyticsCard
              intent="success"
              title="Ready for schedule"
              value={s?.statusReadyForSchedule}
            />
            <AnalyticsCard
              intent="success"
              title="Completed"
              value={s?.statusCompleted}
            />
            <AnalyticsCard
              intent="danger"
              title="Cancelled By User"
              value={s?.statusCancelledByUser}
            />
            <AnalyticsCard
              intent="danger"
              title="Cancelled By Vendor"
              value={s?.statusCancelledByVendor}
            />
          </AnalyticsCardGrid>
        ) : (
          <AggregationNotAvailable />
        )}
      </AnalyticsDrawer>
    </>
  )
}

export default SummaryOrdersDrawer
